(function () {
    'use strict';

    angular
		.module('committeeModule')
		.directive('committee', directive);

    directive.$inject = ['boxTmplScope', 'boxTmplHtml', 'boxTmplLinkFn'];

    function directive(boxTmplScope, boxTmplHtml, boxTmplLinkFn) {
        var directiveScope = _.clone(boxTmplScope);
        directiveScope.highlight = '=';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope',
						 '$controller','committeeService','permissionService',
						 function ($scope,
						 		   $controller, committeeService, permissionService) {
						     // Box template
						     $scope.baseTemplatePath = '/app/shared/committee/committee.[Template].tpl.html';

						     $scope.canEdit = permissionService.hasPermission('ProceduresManagement', 'Committee', 'Edit');

						     // Get Control Lookups
						     committeeService.getAllLookups()
                                 .then(function (lookups) {
                                     $scope.committeeLookups = lookups;
                                 });
						     // Page is dirty
						     $scope.ctxtCtrl = {};
						     $scope.ctxtCtrl.needSaveChanges = false;

						     $scope.pageIsDirty = function () {
						         $scope.ctxtCtrl.needSaveChanges = true;
						         $rootScope.$broadcast('page-is-dirty');
						     };
						     $scope.pageIsNotDirty = function () {
						         $scope.ctxtCtrl.needSaveChanges = false;
						         $rootScope.$broadcast('page-is-not-dirty');
						     };


						     $controller('BoxTmplController', { $scope: $scope });
						 }],
            link: function (scope, elem, attrs) {

                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();